<div class="page-container" [class.loading]="loadingLevel === 'page'">
    <app-header title="settings.signIn.header" [menuService]="settingsMenuService"></app-header>

    <ui-card class="settings-card" [class.loading]="loadingLevel === 'card'">
        <h2 class="no-margin">{{ 'settings.signIn.subHeader' | translate }}</h2>
        <p>{{ 'settings.signIn.description' | translate }}</p>

        <div class="settings">
            <app-sign-in-sso-setting [companySSOSetting]="companySSOSetting" />
            <app-sign-in-mfa-setting [companyMFASetting]="companyMFASetting" [roles]="roles" />
        </div>
    </ui-card>
</div>
